export default __webpack_public_path__ + "static/media/CapreseSub.e4e30a0c.jpg";